import axios from 'axios'
import { axiosClient } from './AxiosClient'

const RentalStatus = {
    ACTIVE: "ACTIVE",
    IN_ACTIVE: "IN_ACTIVE",
    WAITING: "WAITING",
    DISABLE: "DISABLE",
    OVERDUE: "OVERDUE",
    CANCELLED: "CANCELLED",
    EXPIRED: "EXPIRED",
    EXPIRE_SOON: "EXPIRE_SOON"
}

function listAllRental(page, size, callback, errorCallback){
    let url = "/rental/list_all"

    axiosClient.get(url, {
        params: {
            page: page,
            size: size,
            building_id: localStorage.getItem('building_id')
        }
    })
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function createRental(location, floor, zone, contractNo, telephone, detail, startLeaseDate, expiredDate, callback, errorCallback){
    let url = "/rental/create"
    var bodyForm = new FormData()
    bodyForm.append("location", location)
    bodyForm.append("floor", floor)
    bodyForm.append("zone", zone)
    bodyForm.append("contract_no", contractNo)
    if(telephone !== null){
        bodyForm.append("telephone", telephone)
    }
    bodyForm.append("detail", detail)
    bodyForm.append("start_lease_date", startLeaseDate)
    bodyForm.append("expired_date", expiredDate)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function viewRental(rentalId){
    return new Promise((resolve, reject) => {
        const url = `/rental/view`
        axiosClient.get(url, {
            params: {
                rental_id: rentalId
            }
        })
        .then((response) => {
            const data = response.data
            resolve(data)
        })
        .catch((error) => {
            reject(error)
        })
    })
}

function setStatus(rentalId, status){
    const url = `/rental/set_status`
    return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('rental_id', rentalId)
        formData.append('status', status)
        axiosClient.post(url, formData)
        .then((response) => {
            resolve(response.data)
        })
        .catch((error) => {
            reject(error)
        })
    })
}

export { listAllRental, RentalStatus, createRental, viewRental, setStatus }